export default "__VITE_ASSET__Cx3Zg6c8__"